export const MaxDeputatsStunden = [24, 25, 25.5, 26, 26.5, 27, 30, 33, 39] as const;
